import styled from "styled-components";
import { colors } from "../../../styles/variables";
import { Alert } from "../../alerts/Alert";
import { Heading } from "../../Heading";

export const StyledLoginForm = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledLogo = styled.img`
  width: 160px;
  height: 30px;
  object-fit: contain;
  object-position: center;
  align-self: center;
  margin-top: 10px;
  margin-bottom: 30px;
`;

export const StyledForm = styled.form`
  width: 100%;
  margin-top: 32px;
`;

export const StyledLoginButton = styled.div`
  padding: 10px 0;
`;

export const StyledError = styled.span`
  font-size: 14px;
  line-height: 1.3;
  color: ${({ theme }) => theme.color.error};
  margin-top: 5px;
  display: block;
  margin-bottom: 10px;
  text-align: center;
  a {
    color: ${({ theme }) => theme.color.error};
    text-decoration: underline;
  }
`;

export const StyledResetPassword = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  button {
    font-size: 15px;
    color: ${colors.gray600};
    text-decoration: underline;
    font-weight: normal;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 20px;
`;

export const StyledSignup = styled.div`
  width: 100%;
`;

export const StyledHeading = styled(Heading)`
  margin: 70px 0 20px;
`;
